module.exports = __webpack_public_path__ + "static/media/vbn-picture-4.89c78657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-picture-4.jpg
// module id = 581
// module chunks = 0